import { gameKeyMatchesUrl } from '@/services/analyticsGameKey';
import { fetchMarketsIndex, type EngineRest } from './boardIndex';

export interface RouteGameIdentity {
  sport?: string;
  date?: string;
  teamA?: string;
  teamB?: string;
  gameNo?: string;
}

/** Read-only discovery for a cold detail route. Only producer-supplied keys
 * may become stream filters. V2 wins over a legacy key so game two cannot
 * leak into game one. REST discovery does not broaden the live subscription. */
export async function discoverRouteGameKeys(
  rest: EngineRest, sport: string, route: RouteGameIdentity, signal: AbortSignal,
): Promise<string[]> {
  for (const classes of [['moneyline'], ['spread', 'total']]) {
    const rows = await fetchMarketsIndex(rest, { sport, classes }, { signal });
    signal.throwIfAborted();
    const keys = rows.map(row => row.canonicalGameKeyV2 ?? row.canonicalGameKey)
      .filter((key): key is string => typeof key === 'string' && gameKeyMatchesUrl(key, route));
    if (keys.length > 0) return [...new Set(keys)].sort();
  }
  return [];
}
